var exports = {
  "az": "Box__L2WTXZ",
  "wy": "Box_1__qHLheb",
  "pv": "Box_2__FiU9DL",
  "EY": "Text__JU0Fhj",
  "UE": "Text_1__1f-RvO",
};

module.exports = exports;
